import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const initUrbanYellow = (container) => {
    const root = container || document;
    const u_f  = root.querySelector('.js-word-1');
    if (!u_f) return;



    // ── Queryselectors après le guard
    const lines           = root.querySelectorAll('.js-v-line');
    const hBlueprintLines = root.querySelectorAll('.js-h-blueprint-line');
    const hash            = root.querySelector('.js-hash');
    const y_f             = root.querySelector('.js-word-2');
    const galleryItems    = root.querySelectorAll('.js-gallery-item');
    const revealText      = root.querySelector('.js-reveal-text');

    // ── Fix double scrollbar du pin spacer
    document.body.style.overflowX = 'hidden';
    root.addEventListener('barba:leave', () => {
        document.body.style.overflowX = '';
    }, { once: true });

    // ── Split YELLOW en spans lettre par lettre
    const yellowLetters = y_f.textContent.split('');
    y_f.innerHTML = '';
    yellowLetters.forEach(l => {
        const span = document.createElement('span');
        span.style.display = 'inline-block';
        span.style.color = '#ffffff';
        span.textContent = l;
        y_f.appendChild(span);
    });
    const yellowSpans = y_f.querySelectorAll('span');

    // ── Intro
    const tl = gsap.timeline({ delay: 0.2 });

    tl
        .fromTo(lines,
            { scaleY: 0, transformOrigin: 'top center' },
            { scaleY: 1, duration: 1.8, ease: 'power4.inOut', stagger: 0.15 },
            0
        )
        .fromTo(hBlueprintLines,
            { scaleX: 0, transformOrigin: 'left center' },
            { scaleX: 1, duration: 1.4, ease: 'power4.inOut', stagger: 0.15 },
            0.6
        )
        .fromTo(u_f,
            { x: -120, opacity: 0, skewX: -8 },
            { x: 0, opacity: 1, skewX: 0, duration: 0.3, ease: 'expo.out' },
            0.3
        )
        .fromTo(y_f,
            { x: -120, opacity: 0, skewX: -8 },
            { x: 0, opacity: 1, skewX: 0, duration: 0.3, ease: 'expo.out' },
            0.38
        )
        .to(yellowSpans, {
            color: '#facc15',
            stagger: 0.04,
            duration: 0.08,
            ease: 'none',
        }, 0.72);

    // ── Reveal texte intention
    if (revealText) {
        revealText.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                const words = node.textContent.split(' ').filter(w => w.length > 0);
                const fragment = document.createDocumentFragment();
                words.forEach((word, i) => {
                    const span = document.createElement('span');
                    span.textContent = word;
                    span.style.opacity = '0.10';
                    span.style.display = 'inline';
                    fragment.appendChild(span);
                    if (i < words.length - 1) {
                        fragment.appendChild(document.createTextNode(' '));
                    }
                });
                node.replaceWith(fragment);
            }
        });

        const words = revealText.querySelectorAll('span[style*="opacity"]');



        gsap.fromTo(words,
            { opacity: 0.10, filter: 'blur(5px)' },
            {
                opacity: 1,
                filter: 'blur(0px)',
                ease: 'none',
                stagger: { each: 0.1, from: 'start' },
                scrollTrigger: {
                    trigger: revealText,
                    start: 'top 30%',
                    end: '+=1000',
                    scrub: 0.5,
                    pin: true,
                    pinSpacing: true,
                    invalidateOnRefresh: true,
                }
            }
        );
    }

    // ── Parallax
    const mmItem = gsap.matchMedia();
    mmItem.add('(min-width: 768px)', () => {
        galleryItems.forEach((item) => {
            const speed = parseFloat(item.dataset.speed) || -0.05;
            gsap.to(item, {
                y: () => window.innerHeight * speed,
                ease: 'none',
                scrollTrigger: {
                    trigger: item,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                    invalidateOnRefresh: true,
                    pinnedContainer: revealText,
                }
            });
        });
    });

    // ── Lignes H galerie — SVG fixed
    const mmSvg = gsap.matchMedia();
    mmSvg.add('(min-width: 768px)', () => {

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;overflow:visible;z-index:35;';
        document.body.appendChild(svg);

        const pairs = [];

        galleryItems.forEach((item) => {
            const markerTop = item.querySelector('.js-h-marker-top');
            const markerBot = item.querySelector('.js-h-marker-bottom');
            if (!markerTop || !markerBot) return;

            const lTop = makeSvgLine(svg);
            const lBot = makeSvgLine(svg);
            pairs.push({ markerTop, markerBot, lTop, lBot });

            ScrollTrigger.create({
                trigger: item,
                start: 'top 90%',
                invalidateOnRefresh: true,
                onEnter:     () => animateLineIn(lTop, lBot),
                onLeaveBack: () => animateLineOut(lTop, lBot),
            });
        });

        let rafId;
        const update = () => {
            const rects = pairs.map(({ markerTop, markerBot }) => ({
                top: markerTop.getBoundingClientRect().top,
                bot: markerBot.getBoundingClientRect().top,
            }));
            pairs.forEach(({ lTop, lBot }, i) => {
                lTop.setAttribute('y1', rects[i].top);
                lTop.setAttribute('y2', rects[i].top);
                lBot.setAttribute('y1', rects[i].bot);
                lBot.setAttribute('y2', rects[i].bot);
            });
            rafId = requestAnimationFrame(update);
        };

        const init = () => { update(); };
        if (document.readyState === 'complete') init();
        else window.addEventListener('load', init);

        root.addEventListener('barba:leave', () => {
            cancelAnimationFrame(rafId);
            svg.remove();
        });

        return () => {
            cancelAnimationFrame(rafId);
            svg.remove();
        };
    });

    return tl;
};

function makeSvgLine(svg) {
    const w = window.innerWidth;
    const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l.setAttribute('x1', 0);
    l.setAttribute('x2', w);
    l.setAttribute('y1', -9999);
    l.setAttribute('y2', -9999);
    l.setAttribute('stroke', 'white');
    l.setAttribute('stroke-width', '1');
    l.setAttribute('opacity', '0');
    l.setAttribute('stroke-dasharray', w);
    l.setAttribute('stroke-dashoffset', w);
    svg.appendChild(l);
    return l;
}

function animateLineIn(lTop, lBot) {
    gsap.fromTo([lTop, lBot],
        { attr: { strokeDashoffset: window.innerWidth }, opacity: 0 },
        { attr: { strokeDashoffset: 0 }, opacity: 0.4, duration: 1.2, ease: 'power3.out', stagger: 0.08 }
    );
}

function animateLineOut(lTop, lBot) {
    gsap.to([lTop, lBot], {
        attr: { strokeDashoffset: window.innerWidth },
        opacity: 0,
        duration: 0.4,
        ease: 'power2.in',
    });
}